<template>
    <div>
        <div class="sidenav">
            <div class="login-main-text">
                <h2>UMS<br> Login Page</h2>
                <p>Login or register from here to access.</p>
            </div>
        </div>
        <div class="main" style="display: inline-grid;">
            <div class="col-md-6 col-sm-12">
                <div class="login-form">
                    <basic-input label="User Name" :rule="'required'" v-model="user.usrId" placeholder="User Name"/>
                    <basic-input label="Password" type="password" :rule="'required'" v-model="user.usrPw" placeholder="Password" @enterEvent="enterEvent"/>
                    <span  class="form-text border-danger text-danger mb-2" v-if="!check">ID or Password was Incorrect</span>
                    <div>
                        <button type="button" class="btn btn-ums" style="width: 100%" @click="login">Login</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import account from '@/config/account'
    import BasicInput from "@/components/form/input/BasicInput";
    import validation from "@/config/mixin/validation";
    import store from "@/config/vuex/store";
    export default {
        name: "Login",
        components: {BasicInput},
        mixins:[validation],
        data() {
            return {
                user: {
                    usrId:'',
                    usrPw:''
                },
                check: true
            }
        },
        methods: {
            enterEvent: function() {
              this.login()
            },
            login:async function() {
                if(!this.validationCheck()) return;
                if(!await account(this.user,this.$router)) {
                    this.check = false
                } else {
                    this.check = true
                    this.$router.push({path: '/'})
                }
            }
        }
    }
</script>

<style scoped>
    body {
        font-family: "Lato", sans-serif;
    }



    .main-head{
        height: 150px;
        background: #FFF;

    }

    .sidenav {
        height: 100%;
        background-color: #000;
        overflow-x: hidden;
        padding-top: 20px;
    }


    .main {
        padding: 0px 10px;
    }

    @media screen and (max-height: 450px) {
        .sidenav {padding-top: 15px;}
    }

    @media screen and (max-width: 450px) {
        .login-form{
            margin-top: 10%;
        }

        .register-form{
            margin-top: 10%;
        }
    }

    @media screen and (min-width: 768px){
        .main{
            margin-left: 45%;
        }

        .sidenav{
            width: 34%;
            position: fixed;
            z-index: 1;
            top: 0;
            left: 0;
            background-color: #28A69A;
        }

        .login-form{
            margin-top: 130%;
        }

        .register-form{
            margin-top: 20%;
        }
    }


    .login-main-text{
        margin-top: 20%;
        padding: 60px;
        color: #fff;
    }

    .login-main-text h2{
        font-weight: 300;
    }
    .btn-ums {
        color: #fff;
        background-color: #00B900;
    }

    .btn-black{
        background-color: #000 !important;
        color: #fff;
    }
</style>
